export enum OverSpentTypeEnum {
    Premium = "premium",
    National = "national",
    International = "international"
}

export enum OverSpentKeyTypeEnum {
    CREDIT = "credit",
    PREMIUM = "premium",
    NATIONAL = "national",
    INTERNATIONAL = "international"
}